module.exports = __webpack_public_path__ + "static/media/RBCGreyLogo.3a4e3671.png";